export function assertGoogleMaps() {
  if (!window.google?.maps) {
    throw new Error('Could not load google maps');
  }
}

export function decodePath(polyline: string): google.maps.LatLng[] {
  assertGoogleMaps();
  return window.google?.maps?.geometry?.encoding?.decodePath(polyline);
}

export function createLatLngBounds() {
  assertGoogleMaps();
  return new window.google.maps.LatLngBounds();
}
